var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_180_467)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8 14.9C6.47452 14.9 5.4 15.9745 5.4 17.3C5.4 18.6255 6.47452 19.7 7.8 19.7C9.12548 19.7 10.2 18.6255 10.2 17.3C10.2 15.9745 9.12548 14.9 7.8 14.9ZM4 17.3C4 15.2013 5.70132 13.5 7.8 13.5C9.89868 13.5 11.6 15.2013 11.6 17.3C11.6 19.3987 9.89868 21.1 7.8 21.1C5.70132 21.1 4 19.3987 4 17.3Z",
    fill: "#F37261"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1165 5.92756C20.3775 6.21284 20.3577 6.65561 20.0724 6.91653L11.8724 14.4165C11.5872 14.6775 11.1444 14.6577 10.8835 14.3724C10.6226 14.0872 10.6423 13.6444 10.9276 13.3835L19.1276 5.88347C19.4128 5.62255 19.8556 5.64229 20.1165 5.92756Z",
    fill: "#1BA5B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7264 2.18457C16.011 1.92299 16.4539 1.9417 16.7154 2.22637L20.1154 5.92637C20.377 6.21103 20.3583 6.65385 20.0736 6.91543C19.789 7.17702 19.3462 7.15831 19.0846 6.87364L15.6846 3.17364C15.423 2.88898 15.4417 2.44616 15.7264 2.18457Z",
    fill: "#1BA5B0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.027 6.98399C13.312 6.72276 13.7548 6.74201 14.016 7.02699L16.216 9.42699C16.4772 9.71198 16.458 10.1548 16.173 10.416C15.888 10.6772 15.4452 10.658 15.184 10.373L12.984 7.97301C12.7228 7.68802 12.742 7.24523 13.027 6.98399Z",
    fill: "#1BA5B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_180_467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.7c6a9cca592c537264ba2ddcab83ac67.svg";
export { ForwardRef as ReactComponent };